<script setup lang="ts">
import {inject, ref} from 'vue';
import {apps, LegacyOrder, legacyOrderKey} from '@hantera/portal-app';
import AppSlotView from '@/AppSlotView.vue';
import Invoice from './Invoice'

const order = inject(legacyOrderKey, ref<LegacyOrder>(<any>{}));


</script>

<template>
  <div class="invoices">
    <AppSlotView :slot="apps.legacySlots.legacyOrder.invoices.first" />
    <Invoice
      v-for="invoice in order.invoices"
      :key="invoice.invoiceId"
      :invoice="invoice"
      class="invoices__invoice"
    />
    <AppSlotView :slot="apps.legacySlots.legacyOrder.invoices.last" />
  </div>
</template>

<style>
.invoices {
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  gap: 10px;
  margin: 5px;
}
</style>